import { useTrackSubscription } from './useTrack/useTrackSubscription';
import { useTrackAudio } from './useTrack/useTrackAudio';
import { useTrackVideo } from './useTrack/useTrackVideo';
export var useTrack = function (_a) {
    var participant = _a.participant;
    var _b = useTrackSubscription({ participant: participant }), audioTrack = _b.audioTrack, videoTrack = _b.videoTrack;
    var audioOn = useTrackAudio({ audioTrack: audioTrack }).audioOn;
    var videoOn = useTrackVideo({ videoTrack: videoTrack }).videoOn;
    return {
        audioTrack: audioTrack,
        videoTrack: videoTrack,
        audioOn: audioOn,
        videoOn: videoOn,
    };
};
